"use client"

import { useRef, useState } from "react"
import styles from "./styles.module.css"
import { FiUploadCloud } from "react-icons/fi"
import Button from "../../modules/Button/Button"
import toast from "react-hot-toast"

const UploadCSV = ({ onFileUpload }) => {
  const fileInputRef = useRef(null)
  const [dragActive, setDragActive] = useState(false)

  const allowedTypes = ["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]

  const isValidFile = (file) => {
    const name = file.name.toLowerCase()
    return (
      allowedTypes.includes(file.type) ||
      name.endsWith(".csv") ||
      name.endsWith(".xlsx") ||
      name.endsWith(".xls")
    )
  }

  const handleDrag = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true)
    } else if (e.type === "dragleave") {
      setDragActive(false)
    }
  }

  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0]
      if (isValidFile(file)) {
        onFileUpload && onFileUpload(file)
      } else {
        toast.error("Please upload a valid CSV or Excel file (.csv, .xlsx, .xls).")
      }
    }
  }

  const handleClick = () => {
    fileInputRef.current.click()
  }

  const handleChange = (e) => {
    const file = e.target.files[0]
    if (file && isValidFile(file)) {
      onFileUpload && onFileUpload(file)
    } else {
      toast.error("Please upload a valid CSV or Excel file (.csv, .xlsx, .xls).")
    }
  }

  return (
    <Button
      variant="secondary"
      onClick={handleClick}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
      className={styles.csvButton}
      leftIcon={<FiUploadCloud />}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv,.xlsx,.xls,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        style={{ display: "none" }}
        onChange={handleChange}
      />
      Upload Your CSV / Excel
    </Button>
  )
}

export default UploadCSV
